import React from "react";
import { Dropdown } from "semantic-ui-react";
import { getMap } from "../map/mapSelector";
import { useSelector } from "react-redux";
import { COUNTRY_CY, getCountryProperties } from "../data/countries";
import { HOME_PAGE_ROUTE } from "../../app/api/routeConstants";
import { NAVBAR_STYLES } from "../../css/styles";
import { useLocation } from "react-router-dom";

export default function CountrySelector({ navbar, textColour = "white" }) {
  const { pathname } = useLocation();

  const { responsive } = useSelector((state) => state.app);
  const { coverage } = useSelector((state) => getMap(state));

  const coverageCountry = getCountryProperties(coverage.countryCode);

  const CYPRUS_ITEM = getCountryProperties(COUNTRY_CY);

  const countryOptions = [
    {
      key: 1,
      value: CYPRUS_ITEM.value,
      flag: "cy",
      text: CYPRUS_ITEM.name,
      active: false,
      selected: coverageCountry.value === COUNTRY_CY,
    },
    // {
    //   key: "gr",
    //   value: "GREECE",
    //   flag: "eu",
    //   text: "Launching in other countries soon",
    //   active: false,
    //   selected: coverageCountry.value === "GREECE",
    // },
  ];

  // needs at least two countries for the onChange to work
  // check account menu component to see how the arrow can be inverted on open

  return (
    <div
      className={
        (!responsive.isComputer && " ") ||
        (pathname === HOME_PAGE_ROUTE &&
        navbar === NAVBAR_STYLES.navbarTransparent
          ? "navbar-text-transparent-link"
          : "navbar-text-link")
      }
    >
      <Dropdown
        options={countryOptions}
        className="nav-selector"
        defaultValue={coverageCountry.value}
        style={{
          padding: 0,
          fontSize: 16,
          fontFamily: "Lato, sans-serif",
          color: textColour,
          fontWeight: 400,
        }}
        // className={isOpen ? "nav-selector-open" : "nav-selector"}
        // open={false}
        // open={isOpen}
        // onChange={(e, { value }) => handleChange(e, { value })}
        // onClick={() => setIsOpen(!isOpen)}
        // onClick={(event, data) => handleSelectCountry()}
        // onChange={(e, d) => console.log("change")}
      />
    </div>
  );
}
